import { authAction  } from '../actionTypes'
import {Url} from '../../config/config'
import axios from 'axios'
import { isLoggedIn } from '../../utils'
import { Navigate } from 'react-router-dom'


//----------------------------------login-admin--------------------------------------------------


export const ownerLoginInitiate = () => ({
  type: authAction.OWNER_LOGIN_INITIATE
})

export const ownerLoginSuccess = (data) => ({
  type: authAction.OWNER_LOGIN_SUCCESS,
  payload:data
})

export const ownerLoginFailure = (data) => ({
  type: authAction.OWNER_LOGIN_FAILURE,
  payload: data
})

export function ownerLogin(payload) {
  return dispatch => {
     dispatch(ownerLoginInitiate(payload))
      return new Promise((resolve, reject) =>
          axios.post(`${Url}store/storeLogin`, payload)
              .then(response => {
                  if (response.data.status == 200) {
                      dispatch(ownerLoginSuccess(response.data))
                  }
                  else if(response.data.status == 404) {
                    // window.localStorage.setItem('ownerLogin', "")
                  
                  }
                  else{
                    dispatch(ownerLoginFailure(response.data))
                  }
                  resolve(response.data);
              })
              .catch(err => {
                  dispatch(ownerLoginFailure(err))
                  reject(err);
              })


      );
  }
}
//===========================change=password============================================
export const changePasswordInitiate = () => ({
  type:authAction.OWNER_CHANGE_PASSWORD_INITIATE
})

export const changePasswordSuccess = (data) => ({
  type:authAction.OWNER_CHANGE_PASSWORD_SUCCESS,
  payload:data
})

export const changePasswordFailure = (data) => ({
  type:authAction.OWNER_CHANGE_PASSWORD_FAILURE,
  payload: data
})

export function changePassword(payload) {
  return dispatch => {
    const token = isLoggedIn("ownerLogin");
     dispatch(changePasswordInitiate(payload))
      return new Promise((resolve, reject) =>
          axios.post(`${Url}store/changePassword`, payload,{
            headers: { Authorization: `${token}` }
          })
              .then(response => {
                const data = response.data
             
                  if (data.status  === 200){
                      dispatch(changePasswordSuccess(data))
                  } else{
                    dispatch(changePasswordFailure(data))
                  }
                  resolve(data);
              })
              .catch(err => {
                  dispatch(changePasswordFailure(err))
                  reject(err);
              })
      );
  }
}

//==================================Auth==logout====================================================

export const logoutOwnerInitiate = () => ({
  type:authAction.OWNER_LOGOUT_INITIATE
})

export const logoutOwnerSuccess = (data) => ({
  type:authAction.OWNER_LOGOUT_SUCCESS,
  payload:data
})

export const logoutOwnerFailure = (data) => ({
  type:authAction.OWNER_LOGOUT_FAILURE,
  payload: data
})

export function ownerLogout(payload) {
  return dispatch => {
    const token = isLoggedIn("ownerLogin");
   
     dispatch(logoutOwnerInitiate(payload))
      return new Promise((resolve, reject) =>
          axios.post(`${Url}store/storeLogout`,payload,{
            
            headers: { Authorization: `${token}` }
          })
              .then(response => {
           
                  if (response.status === 200){
                      dispatch(logoutOwnerSuccess(response.data))
                  }
                  else{
                    dispatch(logoutOwnerFailure(response.data))
                  }
                  resolve(response.data);
              })
              .catch(err => {
                  dispatch(logoutOwnerFailure(err))
                  reject(err);
              })
      );
  }
}

//------------------------------------------------SENDOTP----------------------------------------------

export const sendOtpInitiate = () => ({
  type:authAction.SEND_OTP_INITIATE
})

export const sendOtpSuccess = (data) => ({
  type:authAction.SEND_OTP_SUCCESS,
  payload:data
})

export const sendOtpFailure = (data) => ({
  type:authAction.SEND_OTP_FAILURE,
  payload: data
})

export function sendOtp(payload) {
  return dispatch => {
     dispatch(sendOtpInitiate(payload))
      return new Promise((resolve, reject) =>
          axios.post(`${Url}store/sendOtpOnEmail` ,payload
          )
              .then(response => {
                const data = response.data
           
                  if (data.code=== 200){
                      dispatch(sendOtpSuccess(data))
                  }
                  else{
                    dispatch(sendOtpFailure(data))
                  }
                  resolve(data);
              })
              .catch(err => {
                  dispatch(sendOtpFailure(err))
                  reject(err);
              })
      );
  }
}


//------------------------------------------------ForgotSENDOTP----------------------------------------------

export const forgotOtpInitiate = () => ({
  type:authAction.FORGOT_SEND_OTP_INITIATE
})

export const forgotOtpSuccess = (data) => ({
  type:authAction.FORGOT_SEND_OTP_SUCCESS,
  payload:data
})

export const forgotOtpFailure = (data) => ({
  type:authAction.FORGOT_SEND_OTP_FAILURE,
  payload: data
})

export function forgotOtp(payload) {
  return dispatch => {
     dispatch(forgotOtpInitiate(payload))
      return new Promise((resolve, reject) =>
          axios.post(`${Url}store/sendOtpOnEmail1` ,payload
          )
              .then(response => {
                const data = response.data
           
                  if (data.code=== 200){
                      dispatch(forgotOtpSuccess(data))
                  }
                  else{
                    dispatch(forgotOtpFailure(data))
                  }
                  resolve(data);
              })
              .catch(err => {
                  dispatch(forgotOtpFailure(err))
                  reject(err);
              })
      );
  }
}

//------------------------------------------------Verify-OTP----------------------------------------------

export const verifyOtpInitiate = () => ({
  type:authAction.VERIFY_OTP_INITIATE
})

export const verifyOtpSuccess = (data) => ({
  type:authAction.VERIFY_OTP_SUCCESS,
  payload:data
})

export const verifyOtpFailure = (data) => ({
  type:authAction.VERIFY_OTP_FAILURE,
  payload: data
})

export function verifyOtp(payload) {
  return dispatch => {
     dispatch(verifyOtpInitiate(payload))
      return new Promise((resolve, reject) =>
          axios.post(`${Url}store/verifyOtp`,payload)
              .then(response => {
                const data = response.data
           
                  if (data.status=== 200){
                      dispatch(verifyOtpSuccess(data))
                  }
                  else{
                    dispatch(verifyOtpFailure(data))
                  }
                  resolve(data);
              })
              .catch(err => {
                  dispatch(verifyOtpFailure(err))
                  reject(err);
              })
      );
  }
}
//===========================forgot=password============================================
export const forgotPasswordInitiate = () => ({
  type:authAction.FORGOT_PASSWORD_INITIATE
})

export const forgotPasswordSuccess = (data) => ({
  type:authAction.FORGOT_PASSWORD_SUCCESS,
  payload:data
})

export const forgotPasswordFailure = (data) => ({
  type:authAction.FORGOT_PASSWORD_FAILURE,
  payload: data
})

export function forgotPassword(payload) {
  return dispatch => {
    const token = isLoggedIn("ownerLogin");
     dispatch(forgotPasswordInitiate(payload))
      return new Promise((resolve, reject) =>
          axios.post(`${Url}store/forgetPassword`, payload,{
            headers: { Authorization: `${token}` }
          })
              .then(response => {
                const data = response.data
             
                  if (data.status  === 200){
                      dispatch(forgotPasswordSuccess(data))
                  }
                  else{
                    dispatch(forgotPasswordFailure(data))
                  }
                  resolve(data);
              })
              .catch(err => {
                  dispatch(forgotPasswordFailure(err))
                  reject(err);
              })
      );
  }
}
//------------------------------------------------Signup----------------------------------------------

export const ownerSignupInitiate = () => ({
  type:authAction.OWNER_SIGNUP_INITIATE
})

export const ownerSignupSuccess = (data) => ({
  type:authAction.OWNER_SIGNUP_SUCCESS,
  payload:data
})

export const ownerSignupFailure = (data) => ({
  type:authAction.OWNER_SIGNUP_FAILURE,
  payload: data
})

export function ownerSignup(payload) {
  return dispatch => {
     dispatch(ownerSignupInitiate(payload))
      return new Promise((resolve, reject) =>
          axios.post(`${Url}store/storeSignup`,payload)
              .then(response => {
                const data = response.data
           
                  if (data.status=== 200){
                      dispatch(ownerSignupSuccess(data))
                  }
                  else{
                    dispatch(ownerSignupFailure(data))
                  }
                  resolve(data);
              })
              .catch(err => {
                  dispatch(ownerSignupFailure(err))
                  reject(err);
              })
      );
  }
}


//------------------------------------------------STORE-CATEGORY----------------------------------------------

export const getOwnerCategoryInitiate = () => ({
  type:authAction.OWNER_CATEGORY_INITIATE
})

export const getOwnerCategorySuccess = (data) => ({
  type:authAction.OWNER_CATEGORY_SUCCESS,
  payload:data
})

export const getOwnerCategoryFailure = (data) => ({
  type:authAction.OWNER_CATEGORY_FAILURE,
  payload: data
})

export function getOwnerCategory(payload) {
  const token = isLoggedIn("ownerLogin");
  return dispatch => {
     dispatch(getOwnerCategoryInitiate(payload))
      return new Promise((resolve, reject) =>
          axios.post(`${Url}admin/categoryDropDown`,payload,
            {
              headers: { Authorization: `${token}` },
            }
          )
              .then(response => {
                const data = response.data
           
                  if (data.status=== 200){
                      dispatch(getOwnerCategorySuccess(data))
                  }
                  else{
                    dispatch(getOwnerCategoryFailure(data))
                  }
                  resolve(data);
              })
              .catch(err => {
                  dispatch(getOwnerCategoryFailure(err))
                  reject(err);
              })
      );
  }
}




export const updateStoreTrafficInitiate = () => ({
  type:authAction.UPDATE_STORE_TRAFFIC_INITIATE
})

export const updateStoreTrafficSuccess = (data) => ({
  type:authAction.UPDATE_STORE_TRAFFIC_SUCCESS,
  payload:data
})

export const updateStoreTrafficFailure = (data) => ({
  type:authAction.UPDATE_STORE_TRAFFIC_FAILURE,
  payload: data
})

export function updateStoreTraffic(payload) {
  const token = isLoggedIn("ownerLogin");
  return dispatch => {
     dispatch(updateStoreTrafficInitiate(payload))
      return new Promise((resolve, reject) =>
          axios.post(`${Url}store/updateStoreTraffic`,payload,
            {
              headers: { Authorization: `${token}` },
            }
          )
              .then(response => {
                const data = response.data
           
                  if (data.status=== 200){
                      dispatch(updateStoreTrafficSuccess(data))
                  }
                  else{
                    dispatch(updateStoreTrafficFailure(data))
                  }
                  resolve(data);
              })
              .catch(err => {
                  dispatch(updateStoreTrafficFailure(err))
                  reject(err);
              })
      );
  }
}



